<template>
  <div class="w-100%" style="color:#333;">

    <!-- 选择日期 -->
      <div class="block" style="margin-top:0px;">
        <span class="demonstration">时间</span>
        <el-date-picker
          v-model="keywordss"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <el-button slot="append" size="small" icon="el-icon-search" :loading="isLoading" @click="reviewAllUsers()"></el-button>
        <span class="m-l-30">小程序在线<span style="font-size:20px;font-weight:700;margin-left:7px;color:#00e;">{{wx_line}}</span></span>
        <span class="m-l-30">企业后台在线<span style="font-size:20px;font-weight:700;margin-left:7px;color:#00e;">{{user_line}}</span></span>
        <span class="m-l-30">总后台在线<span style="font-size:20px;font-weight:700;margin-left:7px;color:#00e;">{{admin_line}}</span></span>
        <div style="margin: 10px 0px;"  >
          <el-row :gutter="10">
            <el-col :span="8">
              <div class="grid-content bg-danger">
                <div class="details">
                  <div class="number">{{usercount}} <span style="font-size:15px;">名</span></div>
                  <div class="desc">今日新增用户</div>
                </div>
                <router-link :to="{ name: 'userList' }" class="more">
            用户列表<i class="el-icon-d-arrow-right more-icon"></i>
              </router-link>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-success">
                <div class="details">
                  <div class="number">{{companycount}} <span style="font-size:15px;">户</span></div>
                  <div class="desc">今日新增企业</div>
                </div>
                <router-link :to="{ name: 'companyList' }" class="more">
            企业列表<i class="el-icon-d-arrow-right more-icon"></i>
              </router-link>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-blue">
                <div class="details">
                  <div class="number">{{billcount}} <span style="font-size:15px;">个</span></div>
                  <div class="desc">今日新增发票</div>
                </div>
                <router-link :to="{ name: 'invoiceList' }" class="more">
            发票列表<i class="el-icon-d-arrow-right more-icon"></i>
              </router-link>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="8">
              <div class="grid-content bg-warning">
                <div class="details">
                  <div class="number">{{daycount3}} <span style="font-size:15px;">元</span></div>
                  <div class="desc">门店消费买单金额</div>
                </div>
                <router-link :to="{ name: 'goodsList' }" class="more">
            消费列表<i class="el-icon-d-arrow-right more-icon"></i>
              </router-link>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-success">
                <div class="details">
                  <div class="number">{{daycount4}} <span style="font-size:15px;">元</span></div>
                  <div class="desc">网上购物金额</div>
                </div>
                <router-link :to="{ name: 'goodsList' }" class="more">
            订单列表<i class="el-icon-d-arrow-right more-icon"></i>
              </router-link>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content" style="background-color:#87AC95">
                <div class="details">
                  <div class="number">{{daycount5}} <span style="font-size:15px;">户</span></div>
                  <div class="desc">商家入驻申请(待处理)</div>
                </div>
                <router-link :to="{ name: 'settledList' }" class="more">
            申请列表<i class="el-icon-d-arrow-right more-icon"></i>
              </router-link>
              </div>
            </el-col>
          </el-row> -->
        </div>
      </div>
    <!-- 选择日期end -->
    <div id="myChart" class="m-t-30" :style= "{width: '100%', height: '450px' }"></div>
  </div>
</template>
<style>
table.hovertable {
    font-family: verdana,arial,sans-serif;
    font-size:14px;
    color:#333333;
    border-width: 1px;
    border-color: #999999;
    width:100%;
    margin-bottom: 25px;
    border-collapse: collapse;
    text-align: center;
}
table.hovertable th {
    background-color:#c3dde0;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #a9c6c9;
}
table.hovertable tr {
    background-color:#E5F2FF;
}
table.hovertable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #a9c6c9;
}
table.hovertable tr:nth-child(even){

background: #FFFFFF;

}
.more-icon{
  line-height: 24px;
}
table.hovertable tr:nth-child(odd) input{

background-color: #E5F2FF;

}
  .details {
    text-align: right;
    padding: 20px 20px 10px;
    color: #ffffff;
    word-wrap: break-word;
  }
  .number {
    font-size: 34px;
  }
  .more{
    display: block;
    padding: 6px 10px 6px 10px;
    position: relative;
    text-transform: uppercase;
    font-weight: 300;
    font-size: 13px;
    height:30px;
    line-height: 30px;;
    opacity: 0.5;
    color: #FFFFFF;
    background-color: rgba(0,0,0,.12);
  }
  .more-icon {
    float: right;
    padding-top: 4px;
  }
  .bg-blue {
    background-color: #20A0FF;
  }
  .bg-success {
    background-color: #13CE66;
  }
  .bg-warning {
    background-color: #F7BA2A;
  }
  .bg-danger {
    background-color: #FF4949;
  }
  .bg-light-black {
    background-color: #324057;
  }
  .bg-sliver {
    background-color: #8492A6;
  }
</style>
<script>
  import http from '../../../assets/js/http'
  import echarts from 'echarts'

  export default {
    data() {
      return {
        loading: false,
        isLoading: false,
        tableData: '',
        activeName: 'first',
        keywordss: '',
        usercount: '0',
        companycount: '0',
        billcount: '0',
        wx_line: '0',
        user_line: '0',
        admin_line: '0',
      }
    },
    mounted () {
      _g.openGlobalLoading()
      this.reviewAllUsers()
    },
    methods: {
      reviewAllUsers() {
        const data = {
          params: {
            keywords: this.keywordss
          }
        }
        this.loading = true
        this.apiGet('admin/index/index', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.isLoading = false
            this.usercount = data.usercount
            this.companycount = data.companycount
            this.billcount = data.billcount
            this.wx_line = data.wx_line
            this.user_line = data.user_line
            this.admin_line = data.admin_line
            this.drawLine(data.list.time, data.list.count, data.list.count1, data.list.count2)
          }, () => {
            this.isLoading = false
            this.drawLine(data.list.time, data.list.count, data.list.count1, data.list.count2)
          })
        })
      },
      drawLine (time, count, count1, count2) {
        // 基于准备好的dom，初始化echarts实例
        var _this = this
        let myChart = echarts.init(document.getElementById('myChart'))
        // 绘制图表
        myChart.setOption({
          title: { text: '流量统计图' },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '2%',
            bottom: '2%',
            containLabel: true
          },
          legend: {
            data: ['新增用户','新增企业','新增发票']
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              interval: 0
            },
            data: time
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            itemStyle: { normal: { label: { show: true }}},
            name: '新增用户',
            type: 'line',
            data: count
          },{
            itemStyle: { normal: { label: { show: true }}},
            name: '新增企业',
            type: 'line',
            data: count1
          },{
            itemStyle: { normal: { label: { show: true }}},
            name: '新增发票',
            type: 'line',
            data: count2
          }]
        })
      },
      init() {
        this.reviewAllUsers()
      }
    },
    created() {
      this.init()
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?61d30b1f